import OnestockCkycContainer from "./OnestockCkycContainer";
import OneStockCkycStore from "./OneStockCkycStore";

export default OneStockCkycStore(OnestockCkycContainer);